import polyfill from '../utils/polyfill';

import annotations from './annotations';
import timelineNodes from './timeline-nodes';

/**
* @param {HTMLNode} rootElement The component dom node
*/
export default function(rootElement) {
  if (!rootElement) {
    return;
  }

  annotations(rootElement);

  polyfill('IntersectionObserver' in window, 'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?features=IntersectionObserver', () => {
    timelineNodes(rootElement);
  });
}
